export const formatNumberComma = (number) => {
  return Number(number).toLocaleString();
};

export const formatNumber = (number) => {
  return Number(number).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
